var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ManagementPage", {
    attrs: { pageName: _vm.$tc("Import Templates", 2) },
    scopedSlots: _vm._u([
      {
        key: "left",
        fn: function() {
          return [
            _c("TableView", {
              attrs: { selectedTemplate: _vm.selectedTemplate },
              on: {
                "open-create-import-form": function($event) {
                  _vm.selectedTemplate = {}
                },
                "clear-selected-item": function($event) {
                  _vm.selectedTemplate = null
                }
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "right",
        fn: function() {
          return [
            _c("Import", {
              attrs: { selectedTemplate: _vm.selectedTemplate },
              on: {
                "clear-selected-item": function($event) {
                  _vm.selectedTemplate = null
                }
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b81616b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b81616b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ImportView.vue
// module id = null
// module chunks = 